<template>
  <div class="searchInputSelect">
    <select
      id="countySelect"
      v-model="currentCounty"
      name="county"
      @change="onCountyChange"
    >
      <option value="">縣市</option>
      <template v-for="(districts, countyName) in districts">
        <option :key="countyName" :value="countyName">{{ countyName }}</option>
      </template>
    </select>
    <select
        name="district"
        class="district"
        v-model="currentDistrict"
    >
      <option value="">請選擇地區</option>
      <template v-if="districts[currentCounty]">
        <option
            v-for="district in districts[currentCounty][0]"
            v-bind:value="district"
            :key="district">
          {{ district }}
        </option>
      </template>
    </select>
    <select
      id="typeSelect"
      v-model="currentClassMetaId"
      name="classMetaId"
    >
      <option value="">類別</option>
      <template v-for="(classMeta, key) in classMetas">
        <option :key="key" :value="classMeta.id">
          {{ classMeta.name }}
        </option>
      </template>
    </select>
<!-- #201 資料太少先暫時隱藏-->
<!--    <select-->
<!--      id="serviceSelect"-->
<!--      v-model="currentServiceClassMetaId"-->
<!--      name="serviceClassMetaId"-->
<!--    >-->
<!--      <option value="">服務項目</option>-->
<!--      <template v-for="(serviceClassMeta, key) in serviceClassMetas">-->
<!--        <option :key="key" :value="serviceClassMeta.id">-->
<!--          {{ serviceClassMeta.name }}-->
<!--        </option>-->
<!--      </template>-->
<!--    </select>-->
<!--    <select-->
<!--        id="markSelect"-->
<!--        name="markSelectId"-->
<!--        v-model="currentMarkSelectId"-->
<!--        v-show="loginCheck"-->
<!--    >-->
<!--      <option value="">標記</option>-->
<!--      <option value="myMark">我的標記</option>-->
<!--    </select>-->
  </div>
</template>

<script>

export default {
  props: [
    'keyword',
    'county',
    'district',
    'classMetaId',
    'serviceClassMetaId',
    'classMetas',
    'serviceClassMetas',
    'markMetas',
    'markSelectId',
    'loginCheck',
    'districtsList'
  ],
  data() {
    return {
      currentCounty: '',
      currentDistrict: '',
      currentClassMetaId: '',
      currentServiceClassMetaId: '',
      currentMarkSelectId: '',
      districts: {},
      times: [
        {
          text: '上午',
          value: 1,
        },
        {
          text: '下午',
          value: 2,
        },
        {
          text: '晚上',
          value: 3,
        },
      ],
      prices: ['0~1000', '1001~5000', '5000以上'],
    };
  },
  watch: {
  },
  mounted() {
    this.resetOption();
  },
  methods: {
    onCountyChange(){
      this.currentDistrict = '';
    },
    resetOption() {
      this.districts = this.districtsList;
      this.currentCounty = this.county;
      this.currentDistrict = this.district;
      this.currentClassMetaId = this.classMetaId;
      this.currentServiceClassMetaId = this.serviceClassMetaId;
      this.currentMarkSelectId = this.markSelectId;
    },
  },
};
</script>
